import styled, { css } from 'styled-components';
import { Box, Card, Stack } from '@mui/material';
import { Button, Typography } from 'components/elements';
import { SRC_TYPES } from './@types';
import { DEFAULT_FONT } from 'commons/styles/font';

export const CardContainer = styled(Card)<{ selected: boolean }>`
  background-color: ${({ selected }) => (selected ? '#6F57E6' : 'white')};
  padding: 15px;
  box-shadow: none;
  border-radius: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  position: relative;
  box-sizing: content-box;
  justify-content: space-between;
  max-width: 245px;
  min-width: 245px;
`;

export const ContainerHeader = styled(Stack)`
  width: 150px;
  height: 60px;
`;

export const ContainerTitle = styled(Stack)`
  width: 130px;
  height: 40px;
`;

export const Title = styled(Typography)`
  font-size: 18px;
  font-weight: 900;
  width: 120px;
  max-width: 213px;
  @supports (-webkit-line-clamp: 2) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: initial;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`;

export const Description = styled(Box)<{ color?: string; fontSize?: string }>`
  color: ${({ color }) => color || '#FFF'};
  font-size: ${({ fontSize }) => fontSize || '28px'};
  font-weight: 600;
  font-family: ${DEFAULT_FONT};
  text-align: center;
  white-space: normal;
  line-height: 1.1;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Header = styled(Stack)`
  display: flex;
  justify-content: start;
  flex-direction: row;
  margin-bottom: 15px;
`;

export const Status = styled(Typography)<{ color: string; disabled: boolean }>`
  align-items: center;
  color: ${({ disabled, color }) => (disabled ? color : '#868686')};
  font-size: 12px;
  font-style: italic;
  margin-top: 5px;
`;

export const SeeMoreButton = styled(Button)<{ selected: boolean }>`
  border-color: ${({ selected }) => (selected ? '#FFF' : '')};
  color: ${({ selected }) => (selected ? '#FFF' : '')};
`;

export const SelectFigurantButton = styled(Button)<{ $colorSelectedFigurant: string }>`
  border-color: ${({ $colorSelectedFigurant }) => $colorSelectedFigurant};
  color: ${({ $colorSelectedFigurant }) => $colorSelectedFigurant};
`;

export const CustomStack = styled(Stack)<{ src?: SRC_TYPES }>`
  gap: 15px;
  min-height: 290px;

  ${({ src }) =>
    src === SRC_TYPES.LICENSE &&
    css`
      min-height: 240px;
    `}
`;
